import { checkBmoVisible } from '@/api'

export default {
  namespaced: true,
  state: {
    isDDGYHidden: false,
  },
  getters: {
    isDDGYHidden: state => state.isDDGYHidden,
  },
  mutations: {
    setDDGYHidden(state, payload) {
        state.isDDGYHidden = payload;
    }
  },
  actions: {
    checkDDGYVisible: ({commit}, params) => {
        const { companyEncode = '' } = params;
        return checkBmoVisible({ companyEncode }).then(res => {
          commit('setDDGYHidden', res.data || false)
        }).catch(() => commit('setDDGYHidden', false))
    }
  },
}
